import { useHoneyGridApiFetch } from '@/queries/useHoneyGridApiFetch'
import { useQuery } from '@tanstack/react-query'

import { gridsQueryKey } from './useGrids'

import type { Grid } from 'honeygrid-types'

export const gridQueryKey = (organizationId: string, gridId: Grid['uuid'], include?: string) =>
	[...gridsQueryKey(organizationId), gridId, ...(include ? [include] : [])] as const

interface GridParams {
	workspaceId?: string
	gridId: Grid['uuid']
	include?: string
	enabled?: boolean
}

export const useGrid = ({ workspaceId = '', gridId, include, enabled = true }: GridParams) => {
	const authFetch = useHoneyGridApiFetch()

	return useQuery<Grid>({
		queryKey: gridQueryKey(workspaceId, gridId, include),
		queryFn: (): Promise<Grid> =>
			authFetch(
				`workspaces/${workspaceId}/grids/${gridId}${include ? `?include=${encodeURIComponent(include)}` : ''}`
			),
		enabled: enabled && !!workspaceId && !!gridId,
	})
}
